<template>
  <div class="app-container">
    <PageHeader title="类目管理"  icon="el-icon-folder" />
    <!-- 操作按钮区域 -->
    <div class="table-toolbar">
      <el-button-group>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增类目</el-button>
        <!-- <el-button type="success" icon="el-icon-download" size="small">导出</el-button> -->
      </el-button-group>
    </div>

    <!-- 数据表格 -->
    <div class="table-box">
      <el-table
        :data="categoryList"
        border
        stripe
        row-key="category_id"
        default-expand-all
        :tree-props="{children: 'children'}"
        style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center"/>
        <el-table-column prop="category_name" label="类目名称" min-width="200" align="center">
          <template slot-scope="scope">
            <span :style="{ 
              paddingLeft: scope.row.parent_id === '0' ? '0' : '24px',
              fontWeight: scope.row.parent_id === '0' ? '600' : 'normal'
            }">{{ scope.row.category_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="类目编码" width="150" align="center"/>
        <el-table-column prop="sort" label="排序" width="80" align="center"/>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small" effect="plain">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="160" align="center"/>
        <el-table-column label="操作" width="280" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="button-wrapper">
              <el-button 
                size="mini" 
                type="primary"
                plain
                icon="el-icon-edit"
                @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button 
                size="mini" 
                type="success"
                plain
                icon="el-icon-plus"
                @click="handleAdd(scope.row)">
                添加子类目
              </el-button>
              <el-button 
                size="mini" 
                type="danger"
                plain
                icon="el-icon-delete"
                @click="handleDelete(scope.row)">
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加/编辑对话框 -->
    <el-dialog 
      :title="dialog.title" 
      :visible.sync="dialog.visible" 
      width="550px" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="custom-dialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="父级类目">
          <el-cascader
            v-model="form.parent_id"
            :options="categoryTreeOptions"
            :props="{
              value: 'category_id',
              label: 'category_name',
              children: 'children',
              checkStrictly: true,
              emitPath: false,
              expandTrigger: 'hover'
            }"
            placeholder="请选择父级类目"
            clearable
            style="width: 100%"
            @change="handleParentChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="类目名称" prop="category_name">
          <el-input v-model="form.category_name" placeholder="请输入类目名称"/>
        </el-form-item>
        <el-form-item label="类目编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入类目编码"/>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="999" style="width: 150px"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>  
import PageHeader from '@/components/common/PageHeader.vue'
import request from '@/utils/request'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'CategoryManage',
  components: { PageHeader },
  data() {
    return {
      categoryList: [],
      loading: false,
      // 对话框
      dialog: {
        visible: false,
        title: ''
      },
      // 表单数据
      form: {
        category_id: '',
        parent_id: '0',
        category_name: '',
        path: '',
        sort: 0,
        status: 1,
        remark: ''
      },
      // 表单校验规则
      rules: {
        category_name: [
          { required: true, message: '请输入类目名称', trigger: 'blur' }
        ]
      },
      treeSelectProps: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      parentOptions: [], // 父级类目选项
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取类目列表
    async getList() {
      try {
        const res = await request({
          url: '/api/v1/category/list',
          method: 'POST',
          data: {}
        })

        if (res.status === 1) {
          // 将列表数据转换为树形结构
          this.categoryList = this.buildTree(res.data || [])
        } else {
          this.$message.error(res.msg || '获取类目列表失败')
        }
      } catch (error) {
        console.error('获取类目列表错误:', error)
        this.$message.error('获取类目列表失败')
      }
    },

    // 添加构建树形结构的方法
    buildTree(list) {
      // 创建一个映射表，用于快速查找节点
      const map = {}
      list.forEach(item => {
        map[item.category_id] = {
          ...item,
          children: []
        }
      })

      // 构建树形结构
      const tree = []
      list.forEach(item => {
        const node = map[item.category_id]
        if (item.parent_id === '0') {
          // 顶级节点直接加入树中
          tree.push(node)
        } else {
          // 非顶级节点加入到父节点的 children 中
          const parent = map[item.parent_id]
          if (parent) {
            parent.children.push(node)
          }
        }
      })

      return tree
    },

    // 新增按钮
    handleAdd(row) {
      this.dialog.title = row ? '新增子类目' : '新增类目'
      this.dialog.visible = true
      this.form = {
        category_id: '',
        parent_id: row ? row.category_id : '0',
        category_name: row ? '' : '顶级类目',
        path: '',
        sort: 0,
        status: 1,
        remark: ''
      }
    },
    // 编辑按钮
    handleEdit(row) {
      this.dialog.title = '编辑类目'
      this.dialog.visible = true
      this.form = {
        category_id: row.category_id,
        parent_id: row.parent_id,
        category_name: row.category_name,
        path: row.path,
        sort: row.sort,
        status: row.status,
        remark: row.remark || ''
      
      }
    },
    // 删除按钮
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该类目吗？', '提示', {
          type: 'warning'
        })
        
        const res = await request({
          url: '/api/v1/category/delete',
          method: 'POST',
          data: {
            category_id: row.category_id
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除类目错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    // 提交表单
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const params = {
              category_id: this.form.category_id || '',
              category_name: this.form.category_name,
              parent_id: this.form.parent_id,
              path: this.form.path,
              sort: this.form.sort,
              status: this.form.status,
              remark: this.form.remark || ''
            }

            const res = await request({
              url: '/api/v1/category/save',
              method: 'POST',
              data: params
            })

            if (res.status === 1) {
              this.$message.success('保存成功')
              this.dialog.visible = false
              this.getList()
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            console.error('保存类目错误:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },
    // 初始化父级类目选项
    initParentOptions() {
      // 递归构建类目树
      const buildCategoryTree = (categories) => {
        return categories.map(category => {
          const node = {
            id: category.id,
            name: category.name,
            children: []
          }
          
          // 如果有子类目，递归处理
          if (category.children && category.children.length > 0) {
            node.children = buildCategoryTree(category.children)
          }
          
          return node
        })
      }

      // 添加根目录选项
      const root = {
        id: '0',
        name: '根目录',
        children: buildCategoryTree(this.categoryList)
      }
      
      // 设置父级类目选项
      this.parentOptions = [root]
      
      // 如果是编辑状态，需要找到并设置当前节点的父级类目
      if (this.form.parentId) {
        const findParentNode = (nodes, targetId) => {
          for (const node of nodes) {
            if (node.children) {
              for (const child of node.children) {
                if (child.id === targetId) {
                  this.form.parentId = node.id
                  this.form.parentName = node.name
                  return true
                }
                if (findParentNode(child.children || [], targetId)) {
                  return true
                }
              }
            }
          }
          return false
        }
        
        findParentNode([root], this.form.id)
      }
    },
    // 处理父级类目变化
    handleParentChange(value) {
      if (!value || value === '0') {
        this.form.parent_id = '0'
        this.form.category_name = '顶级类目'
      } else {
        this.form.parent_id = value
        this.form.category_name = ''
      }
    }
  },
  computed: {
    categoryOptions() {
      const formatOptions = (list, level = 0) => {
        return list.map(item => {
          const prefix = '　'.repeat(level)
          const option = {
            category_id: item.category_id,
            label: `${prefix}${level > 0 ? '├ ' : ''}${item.category_name}`
          }
          
          if (item.children && item.children.length > 0) {
            return [option, ...formatOptions(item.children, level + 1)]
          }
          
          return option
        }).flat()
      }
      
      return formatOptions(this.categoryList)
    },
    categoryTreeOptions() {
      // 过滤出顶级类目（parent_id 为 '0' 的类目）
      const topLevelCategories = this.categoryList.filter(item => item.parent_id === '0')
      
      // 构建树形结构
      const buildTree = (categories) => {
        return categories.map(item => {
          const node = {
            category_id: item.category_id,
            category_name: item.category_name,
            children: item.children && item.children.length > 0 ? buildTree(item.children) : []
          }
          return node
        })
      }

      // 添加顶级类目选项，与其他 parent_id 为 '0' 的类目在同一级别
      return [
        {
          category_id: '0',
          category_name: '顶级类目',
          children: []
        },
        ...topLevelCategories.map(item => ({
          category_id: item.category_id,
          category_name: item.category_name,
          children: item.children && item.children.length > 0 ? buildTree(item.children) : []
        }))
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.css';

.custom-dialog {
  .el-form-item {
    margin-bottom: 20px;
  }
}

:deep(.el-table__row--level-0) {
  font-weight: 600;
  background: #fafafa !important;
}

.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .el-button {
    margin: 0;
    padding: 6px 10px;
    
    [class^="el-icon-"] {
      margin-right: 4px;
    }
    
    &.el-button--mini {
      font-size: 12px;
    }
  }
}

:deep(.el-table) {
  .el-table__cell {
    padding: 8px 0;
  }
  
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.is-left {
      justify-content: flex-start;
    }
  }
}

:deep(.el-tag) {
  border-radius: 2px;
  
  &.el-tag--success {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
  }
  
  &.el-tag--info {
    background-color: #f4f4f5;
    border-color: #e9e9eb;
  }
}

.dealer-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style> 